module.exports = __webpack_public_path__ + "img/shape9.a40d5b67.png";